import React, { useEffect } from "react";
import GenericHeader from "./GenericHeader";
import Footer from "./Footer";
import { Outlet, useNavigate } from "react-router-dom";
import { isPrimaryDomain } from "../utils";
import { Container } from "@mui/material";
import { useSelector } from "react-redux";
import { urlSegmentRegex } from "../config";

export default function GenericLayout() {
  const navigate = useNavigate();

  const prospectAppId = useSelector((state) => state.token.prospectAppId);
  const authToken = useSelector((state) => state.token.token);
  const productType = useSelector((state) => state.token.productType);
  const appId = useSelector((state) => state.token.appId);

  const pathName = window.location.pathname;
  const excludedPaths = [`/privacy-policy`, `/terms-of-use`, `/data-retention-policy`, `/grievance-redressal-policy`];
  const isSegmentPath = isPrimaryDomain && pathName?.slice(1)?.match(urlSegmentRegex);

  // prettier-ignore
  useEffect(() => {
    if (!excludedPaths.includes(pathName)) {
      if (!prospectAppId && (pathName === `/verification` || pathName === `/credit-cards`)) {
        // if apply loan is not done but jumped to verification, redirect to home
        navigate(isPrimaryDomain ? '/login' : `/`);
      }
      else if (!prospectAppId && (pathName === `/verification` || pathName === `/cards-unsecured`)) {
        // if apply loan is not done but jumped to verification, redirect to home
        navigate(isPrimaryDomain ? '/login' : `/`);
      }
      else if (!prospectAppId && (pathName === `/verification` || pathName === `/cards-secured`)) {
        // if apply loan is not done but jumped to verification, redirect to home
        navigate(isPrimaryDomain ? '/login' : `/`);
      }
      else if (!isPrimaryDomain && (!prospectAppId || !authToken) && pathName === `/products`) {
        // if apply loan or verification is not done but jumped to product type selection, redirect to home
        navigate(`/`);
      }
      else if (prospectAppId && authToken && !productType && pathName !== (isPrimaryDomain ? '/' : `/products`)) {
        // if apply loan and verification is done but product type selection is pending, redirect to products
        navigate(isPrimaryDomain ? '/' : `/products`);
      }
      else if (prospectAppId && authToken && productType && (pathName === (isPrimaryDomain ? '/login' : `/`) || pathName === "/verification")) {
        // if apply loan and verification is done but product type selection is pending, redirect to products
        navigate(isPrimaryDomain ? '/' : `/products`);
      }
      else if (prospectAppId && authToken && productType === "Personal Loans" && appId) {
        // if apply loan, verification and welcome back/user detail is done, redirect to offers
        navigate(`/user/offers`);
      } else if (prospectAppId && authToken && productType === "Personal Loans" && !appId) {
        // if apply loan and verification done but welcomeback/user detail is pending, redirect to welcomeback
        navigate(`/user/welcome-back`);
      }
      else if (prospectAppId && authToken && productType && !isSegmentPath) {
        if (productType === "Personal Loans") {
          navigate(`/user/welcome-back`);
        } else if (productType === "Affordable Housing Loan") {
          navigate(`/user/housing-welcome-back`);
        } else if (productType === "Gold Loans") {
          navigate(`/user/gold-welcome-back`);
        } else if (productType === "Business Loans") {
          navigate(`/user/business-welcome-back`);
        } else if (productType === "Credit Cards") {
          navigate(`/credit-cards`);
        } else if (productType === "Unsecured Cards") {
          navigate(`/cards-unsecured`);
        } else if (productType === "Secured Cards") {
          navigate(`/cards-secured`);
        }
      }
    }
  }, [pathName]);

  return (
    <>
      <GenericHeader />
      <Container maxWidth="xl">
        <Outlet />
      </Container>
      <Footer />
    </>
  );
}
